module.exports = __webpack_public_path__ + "img/inmac.72180ab8.png";